import React from 'react';

// Componente TherapyScope
interface TherapyItemProps {
  icon: string;
  title: string;
  desc: string;
  color: string;
}

const TherapyItem: React.FC<TherapyItemProps> = ({ icon, title, desc, color }) => (
  <div className="bg-white p-8 rounded-3xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow group h-full">
    <div className={`w-12 h-12 rounded-2xl flex items-center justify-center text-xl mb-6 transform group-hover:-translate-y-1 transition-transform ${color}`}>
      <i className={icon}></i>
    </div>
    <h3 className="text-xl font-black text-dark mb-4">{title}</h3>
    <p className="text-sm text-gray-500 font-medium leading-relaxed">
      {desc}
    </p>
  </div>
);

const TherapyScope: React.FC = () => {
  return (
    <section id="terapias" className="py-24 bg-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-black text-medical mb-6 leading-tight">
            No es solo quimioterapia. <br/>
            <span className="text-onco italic">Es el espectro completo.</span>
          </h2>
          <p className="text-lg text-gray-500 font-medium">
            OncoFHIR Prescribe soporta todo el arsenal terapéutico oncológico moderno en un solo lugar.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          <TherapyItem 
            icon="fas fa-syringe"
            title="Quimioterapia"
            color="bg-medical/10 text-medical"
            desc="Control de citotóxicos tradicionales. Soporta protocolos multi-droga como FOLFOX, R-CHOP, AC, TCH y los que use su práctica."
          />
          <TherapyItem 
            icon="fas fa-dna"
            title="Inmunoterapia"
            color="bg-fhir/10 text-fhir"
            desc="Gestión de inhibidores de checkpoint como Pembrolizumab y Nivolumab con dosificación precisa."
          />
          <TherapyItem 
            icon="fas fa-crosshairs"
            title="Terapias Dirigidas"
            color="bg-onco/10 text-onco"
            desc="TKIs y anticuerpos monoclonales dosificados por peso o dosis fijas con validación de estabilidad."
          />
          <TherapyItem 
            icon="fas fa-shield-virus"
            title="Soporte"
            color="bg-dark/10 text-dark"
            desc="Manejo de antieméticos, factores de crecimiento y premedicación integrada al flujo principal."
          />
        </div>
      </div>
    </section>
  );
};

export default TherapyScope;